<script>
	import Icone from '../../componentes/Icone.svelte';
	
	export let titulo = "";
	export let subtitulo = "";
	export let largura = 4;
	export let deslocamento = 4;
	export let icone = "";
	export let tamanhoIcone = "64";
	export let correcaoY = "0px";
	export let iconePng = false;
	export let iconePngArquivo = "";
	export let exibirBox = true;
	
	let corIcone = "#000";
</script>

<style>
	.mb {
		margin-bottom: 1.5rem !important;
	}
</style>

<main>
	<section class="hero is-fullheight bgc-1">
		<div class="hero-body">
			<div class="container">
				{#if icone != ""}
				<figure 
					class="container image is-{tamanhoIcone}x{tamanhoIcone}"
					style="margin-bottom: {correcaoY}">
					<Icone tipo="{icone}" cor={corIcone} />
				</figure>
				{/if}

				{#if iconePng == true}
				<figure 
					class="container image is-{tamanhoIcone}x{tamanhoIcone}"
					style="margin-bottom: {correcaoY}">
					<img src="{iconePngArquivo}" alt="Icone" />
				</figure>
				{/if}

				<div class="column is-{largura} is-offset-{deslocamento}">
					<div class="mb has-text-centered">
						{#if titulo != ""}
						<h3 class="title has-text-primary">{titulo}</h3>
						{/if}

						{#if subtitulo != ""}
						<p class="is-size-6 subtitle has-text-primary">{subtitulo}</p>
						{/if}
					</div>

					{#if exibirBox}
					<div class="box">
						<slot></slot>
					</div>
					{:else}
					<slot></slot>
					{/if}
				</div>
			</div>
		</div>
	</section>
</main>